import React, { useEffect } from 'react';
import './modalBase.scss';
import Button, { ButtonType, ButtonState } from '../button/Button';
import { IconType } from '../icon/Icon';

export type ModalBaseProps = {
  isOpen: boolean;
  title?: string;
  onClose: () => void;
  closeOnEsc?: boolean;
  closeOnOverlayClick?: boolean;
  showCloseButton?: boolean;
  children: React.ReactNode;
  labels?: any;
};

export const ModalBase: React.FC<ModalBaseProps> = ({
  isOpen,
  title,
  onClose,
  closeOnEsc = true,
  closeOnOverlayClick = true,
  showCloseButton = true,
  children,
}) => {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && closeOnEsc) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [closeOnEsc, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      onClick={() => closeOnOverlayClick && onClose()}
    >
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {(showCloseButton || title) && (
          <div className="modal-header">
            {title && <h2 className="modal-title">{title}</h2>}
            {showCloseButton && (
              <Button
                type={ButtonType.TERTIARY}
                state={ButtonState.DEFAULT}
                extraClasses="info-close"
                onClick={onClose}
                aria-label="Close info panel"
                icon={IconType.Close}
              />
            )}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
